module.exports = __webpack_public_path__ + "static/media/back.262a4ca1.svg";